import * as React from 'react';

function IconRestore() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.14407 12.3816C4.14407 7.16178 8.31407 2.95294 13.4041 3.09736C18.0941 3.23146 22.0141 7.27525 22.1441 12.1134C22.2841 17.3641 18.1941 21.6658 13.1441 21.6658C11.0641 21.6658 9.14407 20.9334 7.62407 19.7058C7.15407 19.3241 7.12407 18.602 7.54407 18.1584C7.90407 17.787 8.46407 17.7561 8.86407 18.0759C10.0441 19.0352 11.5341 19.6026 13.1441 19.6026C17.0441 19.6026 20.1941 16.3119 20.1441 12.2784C20.0941 8.44094 16.9641 5.2121 13.2441 5.16052C9.32407 5.10894 6.14407 8.35841 6.14407 12.3816H7.94407C8.38407 12.3816 8.61407 12.9386 8.29407 13.2584L5.50407 16.1468C5.30407 16.3531 4.99407 16.3531 4.79407 16.1468L2.00407 13.2584C1.68407 12.9386 1.90407 12.3816 2.35407 12.3816H4.14407ZM12.1441 9.02894C12.1441 8.60599 12.4841 8.25525 12.8941 8.25525C13.3141 8.25525 13.6441 8.60599 13.6441 9.01862V12.526L16.5241 14.29C16.8741 14.5066 16.9941 14.9811 16.7841 15.3525C16.5741 15.7136 16.1141 15.8374 15.7541 15.6207L12.6341 13.7123C12.3341 13.5266 12.1441 13.1862 12.1441 12.8251V9.02894Z"
        fill="#FF7020"
      />
    </svg>
  );
}

export default IconRestore;
